import Tokens from '@nokia-csf-uxr/freeform-design-tokens';

import alpha from '../styles/utils/alpha';
/**
 * `getOverlayStyle` is a function that returns the overlay CSS declaration block containing `backgroundColor` and `backdropFilter` declarations.
 * `getOverlayStyle` has two variants `dark` and `light`.
 * Parameters:
 * `isMaskLight` (boolean)[false]: Set `true`, to receive the bright(light) variant.
 */
const getOverlayStyle = ({ isMaskLight } = { isMaskLight: false }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  width: '100%',
  height: '100%',
  backgroundColor: isMaskLight ? alpha(Tokens.COLORS.WHITE, Tokens.OPACITY.OPACITY_76) : alpha(Tokens.COLORS.BLACK, Tokens.OPACITY.OPACITY_54)
});

/**
 * `getBackgroundStyle` is a function that returns the background (container) CSS declaration block containing `filter` declaration.
 * Parameters:
 * `isMaskLight` (boolean)[false]: Set `true`, to receive the bright(light) variant.
 */
const getBackgroundStyle = ({ isMaskLight } = { isMaskLight: false }) => {
  /* isMaskLight is kept for backward compatibility. */
  const lightMask = {
    filter: 'blur(0.25rem)'
  };
  const darkMask = {
    filter: 'blur(0.25rem)'
  };
  if (isMaskLight) {
    return (lightMask);
  }
  return (darkMask);
};

/**
 * `applyMaskBlur` is a function that applies CSS blur filter to the given element.
 * Parameters:
 * `ref`: The reference of the target element.
 * `isMaskLight` (boolean)[false]: Set `true`, to return the bright(light) variant.
 */
const applyMaskBlur = ({ ref, isMaskLight }) => {
  if (ref && ref.current) {
    ref.current.style.filter = getBackgroundStyle(isMaskLight).filter; // eslint-disable-line no-param-reassign
  }
};

/**
 * `removeMaskBlur` is a function that removes CSS blur filter from the given element.
 * Parameters:
 * `ref`: The reference of the target element.
 */

const removeMaskBlur = ({ ref }) => {
  if (ref && ref.current) {
    ref.current.style.filter = 'none'; // eslint-disable-line no-param-reassign
  }
};

export { getOverlayStyle, getBackgroundStyle, applyMaskBlur, removeMaskBlur };